module.exports = __webpack_public_path__ + "img/32.d92992da.jpg";